import { AppService } from "app/services/app.service";

import { ConfigZonasArea } from "app/models/config-zonas-area.model";
import { Observable } from "rxjs";
import { ConfigZonasGrupos } from "app/models/config-zonas-grupos.model";

export abstract class AbConfigZonas extends AppService {
  abstract getAllConfigZonas(): Observable<any>;
  abstract getAllConfigZonasPromise();
  abstract saveConfigsZonas(configZonasArea: Array<ConfigZonasArea>): Observable<any>;
  abstract getAllConfigZonasGrupos();
  abstract saveConfigsZonasGrupos(configsZonasGrupos: Array<ConfigZonasGrupos>);
  abstract getZonas(configZonaId, tipo);
  abstract salvarZonas(configsZonasGrupos): Observable<any>;
}